export const FALLBACK_PARENT = "Sin especie";
export const normalize = (str) => (str ?? "").toString().trim();

export function groupCrops(items, extraParents = []) {
	const map = new Map();

	for (const it of items) {
		const parent = normalize(it.parent_name) || FALLBACK_PARENT;
		if (!map.has(parent)) map.set(parent, []);
		map.get(parent).push(it);
	}

	for (const p of extraParents) {
		const name = normalize(p.name) || FALLBACK_PARENT;
		if (!map.has(name)) map.set(name, []);
	}

	return Array.from(map.entries())
		.sort(([a], [b]) => a.localeCompare(b, "es", { sensitivity: "base" }))
		.map(([parent, arr]) => [parent, arr.slice().sort((x, y) => x.name.localeCompare(y.name, "es", { sensitivity: "base" }))]);
}
